import { COLORS } from '../design/tokens';

/**
 * Status tint for generated cover artwork.
 *
 * Reads from the token map rather than inlining hex, which is what keeps the artwork in
 * step with the site around it — see the note at the top of tokens.ts on why the palette
 * has to exist in TypeScript at all.
 */
export function statusTint(status: string): string {
  switch (status) {
    case 'Live':
      return COLORS.live;
    case 'InDevelopment':
      return COLORS.dev;
    case 'InProduction':
    default:
      return COLORS.prod;
  }
}
